<template>
  <div class="modal" v-if="seen">
    <div class="deletefile">
      <span @click="closebox" class="closefile">
        <img src="@/assets/Close Button.svg" />
      </span>
      <div class="d-flex justify-content-center align-items-center mt-4">
        <img src="@/assets/trash-can.svg" />
      </div>
      <div class="header d-flex justify-content-center align-items-center mt-2">
        <h6><strong>Delete file?</strong></h6>
      </div>
      <div class="cgn">
        <div class="cgn text-center my-2">
          <span>Are you sure you want to delete?</span>
        </div>
        <ul class="selected_files">
          <li v-for="(name, index) in names" :key="index">
            <span>
              <svg style="width:14px;height:14px" viewBox="0 0 24 24">
                <path fill="#0c0" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" />
              </svg>
            </span>
            &nbsp;
            {{ str_text(name) }}
          </li>
        </ul>
      </div>
      <div class="save" v-if="!is_public">
        <span class="btn-move-to-trash" @click="trash" v-if="base != 'public'">
          Move to trash
        </span>
        <span class="btn-delete-permanently" @click="permanent">
          Delete permanently
        </span>
      </div>
      <div class="save" v-if="is_public">
        <span class="btn-delete" @click="permanent">
          Delete
        </span>
      </div>
    </div>
  </div>
</template>
<style scoped>
.cgn {
  display: flex;
  flex-direction: column;
}

.cgn span {
  margin-bottom: .4em;
}

.header {
  padding: .5em 0 0 0 !important;
}

.header h3 {
  font-size: 22px;
  font-weight: bold;
}

.save {
  margin-top: 0 !important;
}

.cgn {
  display: flex;
  flex-direction: column;
}

.cgn span {
  margin-bottom: .4em;
  font-size: 14px;
}

.deletefile {
  padding: 2em !important;
}

.modal div.deletefile {
  width: 420px !important;
}

.modal div.deletefile div {
  width: 100% !important;
  margin-left: 0 !important;
}

.save {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}

.selected_files {
  height: 200px;
  overflow-y: auto;
}

.save span {
  flex: 1 !important;
}

.save .btn-move-to-trash {
  background: #3F96D1 !important;
  color: #fff !important;
  font-size: 13px !important;
}

.save .btn-delete-permanently {
  background: transparent !important;
  border: 1px solid #FC6D6C !important;
  font-size: 13px !important;
  color: #FC6D6C !important;
}

.save .btn-delete {
  background: transparent !important;
  border: 1px solid #FC6D6C !important;
  font-size: 13px !important;
  color: #FC6D6C !important;
}

.modal div.deletefile .closefile {
  top: 13px !important;
  right: 13px !important;
}
</style>

<script>
import cookies from '@/services/cookies'
export default {
  data() {
    return {
      names: [],
      seen: false,
      index: null,
      loader: false,
      error: false,
      id: null,
      found: false,
      is_public: false,
      base: ''
    }
  },
  methods: {
    logincall() {
      this.$parent.logincall()
    },
    str_text(str) {
      return str.length > 40 ? str.substr(0, 40) + '...' : str
    },
    load() {
      let that = this
      this.names = []
      this.base = localStorage.getItem('db')

      let indexes = Object.values(that.$store.getters.GET_FILES_INDEX)
      indexes.forEach(index => {
        that.names.push(that.$store.getters.DIRECTORY_CHILDREN[index].dir)
      })
      this.seen = true
      this.error = false
      this.loader = false
      this.found = false
      //this.is_public = this.$store.getters.DIRECTORY_CHILDREN[index].is_public
    },
    trash() {
      this.seen = false
      this.$parent.grouptrash()
    },
    permanent() {
      this.seen = false
      this.$parent.grouppermanent()
    },
    closebox() {
      this.names = []
      this.seen = false
    }
  }
}
</script>
